import axios from "axios";
import { getBaseUrl } from "../environment-url";
const SAP_API = axios.create({
  baseURL: getBaseUrl(process.env.REACT_APP_NODE_ENV, "SAP_API"),
  responseType: "json",
  withCredentials: false,
  timeout: 10000, // 10 seconds
});
//Add a response interceptor
SAP_API.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response && error.response.status === 401) {
      console.log("***********Unauthorized Error**********");
    }
    return Promise.reject(error);
  }
);
export default SAP_API;